import { Box } from '@pets-ui/Box/Box'
import { Container } from '@pets-ui/Container/Container'
import { colors } from '@pets-ui/tokens/colors.stylex'

import { VStack } from '@pets-ui/VStack/VStack'
import { type ReactNode, useRef } from 'react'
import { HEADER_HEIGHT } from '../../constants'
import { useResizeObserver } from '../../hooks/useResizeObserver'
import { MerchantSelector } from '../MerchantSelector/MerchantSelector'
import { StickyOffsetContext } from './useStickyOffset'

const FOOTER_RESERVED_SPACING = 48

interface PageLayoutProps {
  brandSelector?: ReactNode
  footer?: ReactNode
  children: ReactNode
  fullWidth?: boolean
}

export const PageLayout = ({ brandSelector, footer, children, fullWidth }: PageLayoutProps) => {
  const brandSelectorRef = useRef<HTMLDivElement>(null)
  const dimensions = useResizeObserver(brandSelectorRef)
  const stickyOffset = HEADER_HEIGHT + (dimensions?.height ?? 0)

  return (
    <Box backgroundColor={colors.grey100} minHeight="100vh">
      {brandSelector && (
        <Box rootRef={brandSelectorRef} position="sticky" top={HEADER_HEIGHT} backgroundColor={colors.grey100} zIndex={10} pb={4}>
          <Container px={4} pt={4}>
            <VStack gap={4}>
              {brandSelector}
              <MerchantSelector />
            </VStack>
          </Container>
        </Box>
      )}
      <StickyOffsetContext.Provider value={stickyOffset}>
        {fullWidth
          ? (
            <Box pb={footer ? FOOTER_RESERVED_SPACING : 0}>
              {children}
            </Box>
          )
          : (
            <Container px={4}>
              <Box pb={footer ? FOOTER_RESERVED_SPACING : 0}>
                {children}
              </Box>
            </Container>
          )}
      </StickyOffsetContext.Provider>
      {footer}
    </Box>
  )
}
